import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';
import { formatDate } from '../utils/dateUtils';

const DuplicateBadge = ({ order }) => {
    const { t, i18n } = useTranslation();

    if (!order?.isPotentialDuplicate) return null;

    const duplicateOf = order.potentialDuplicateOf;

    return (
        <div className="group/dup relative flex items-center gap-1 px-2.5 py-0.5 rounded-lg text-[10px] font-black uppercase tracking-widest bg-red-50 text-red-600 border border-red-100 cursor-help animate-pulse">
            <AlertTriangle size={12} />
            <span>{t('orders.badges.duplicate')}</span>

            {/* Popover */}
            {duplicateOf && (
                <div className="absolute left-0 top-full mt-2 w-64 bg-white rounded-2xl shadow-2xl border border-red-100 p-4 opacity-0 invisible group-hover/dup:opacity-100 group-hover/dup:visible transition-all z-[30] pointer-events-none text-gray-700 normal-case font-medium">
                    <p className="text-red-700 font-bold text-xs uppercase tracking-wider mb-2 flex items-center gap-2">
                        <AlertTriangle size={14} /> {t('orders.messages.similar_order_found')}
                    </p>
                    <div className="space-y-1 text-[11px]">
                        <p className="flex justify-between items-center gap-2">
                            <span className="text-gray-400 font-bold uppercase tracking-widest text-[9px]">{t('orders.messages.sheet_date')}:</span>
                            <span className="font-bold text-gray-700">{formatDate(duplicateOf?.orderDate, i18n.language)}</span>
                        </p>
                        <div className="pt-1.5 mt-1.5 border-t border-red-50 space-y-1">
                            <p className="flex justify-between">
                                <span className="text-gray-400">Order:</span>
                                <span className="font-bold text-gray-700">{duplicateOf?.orderId ? `#${duplicateOf.orderId}` : '---'}</span>
                            </p>
                            <p className="flex justify-between">
                                <span className="text-gray-400">Status:</span>
                                <span className="font-bold text-gray-700 italic">
                                    {duplicateOf?.status ? t(`status.order.${duplicateOf.status}`) : '---'}
                                </span>
                            </p>
                            <p className="flex justify-between">
                                <span className="text-gray-400">Assigned to:</span>
                                <span className="font-bold text-gray-700">
                                    {duplicateOf?.assignedTo?.name || t('orders.table.unassigned')}
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DuplicateBadge;
